module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/Pencils-p-1600-2c6bb18a0a03b4318225831091d0de8a.png";